import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetPaymentControl } from 'src/store';

export const useResetPaymentControl = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetPaymentControl());
    };
  }, [dispatch]);
};
